export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTrees40.7036274d.svg";